import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import { SidenavService } from '@app/core/services/container/sidenav.service';
import { DataSource } from '@components/data/data-table-new/datasource/datasource.component';
import { DataTableState } from '@components/data/data-table-new/state/state.model';
import { StateService } from '@components/data/data-table-new/state/state.service';
import { combineLatest, Observable, Subject } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { Division } from '../../models/division.interface';
import { Section, SectionValue } from '../../models/section.interface';
import { AssignDivisionComponent } from '../../pages/section/section-new/section-new-form/assign-division/assign-division.component';
import { DivisionService } from '../../services/division.service';
import { SectionService } from '../../services/section.service';

@Component({
  selector: 'vfs-division-table-divisions-assigned',
  templateUrl: './division-table-divisions-assigned.component.html',
  styleUrls: ['./division-table-divisions-assigned.component.scss']
})
export class DivisionTableDivisionsAssignedComponent implements OnInit, OnChanges {
  @Input() readonly = false;
  dataSource = new DataSource<Division>();
  stateSubject$ = new Subject<DataTableState>();
  tableState$: Observable<DataTableState>;
  displayedColumns$: Observable<string[]>;
  sections: Section[];

  userDivisions: Division[];
  diffDivisions: Division[] = [];

  get divisions(): Division[] {
    return this.assignableDivisions;
  }

  set divisions(divisions: Division[]) {
    this.assignableDivisions = divisions;
  }

  @Input() assignableDivisions: Division[] = [];
  @Output() assignableDivisionsChange = new EventEmitter<Division[]>();
  @Input() stateId: string;
  @Input() disabled = false;
  @Input() titleCustom: object = null;

  changes$ = new Subject();
  all$: Observable<any>;

  constructor(
    @Inject('StateService') protected stateService: StateService,
    protected sectionService: SectionService,
    protected sidenavService: SidenavService,
    protected divisionService: DivisionService
  ) {}

  ngOnInit() {
    this.divisionService.getOfLoggedUser().pipe(
      map(divisions => {
        this.userDivisions = divisions;
      })
    );
    // TODO: rethink about init it within sort directive
    const state: DataTableState = this.getState();
    if (state.sort.column === '') {
      state.sort.column = 'description';
      this.stateService.update(state);
    }

    this.tableState$ = this.stateSubject$.pipe(startWith(this.getState()));

    this.all$ = combineLatest([this.tableState$, this.changes$.pipe(startWith([]))]).pipe(
      tap(result => {
        this.refreshData(result[0]);
      })
    );

    this.displayedColumns$ = this.getDisplayedColumns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assignableDivisions && !changes.assignableDivisions.firstChange) {
      this.changes$.next();
    }
  }

  refreshData(state: DataTableState) {
    this.dataSource.loading = true;
    let divisions = [];
    this.divisions.forEach(division => {
      let current = {
        description: division.description,
        active: division.active,
        id: division.id
      };
      division.divisionSectionValues.forEach(dsv => {
        // FIXME: Rethink this
        if ((dsv.sectionValue as SectionValue).section !== undefined) {
          let section = (dsv.sectionValue as SectionValue).section;
          current[section as string] = (dsv.sectionValue as SectionValue).description;
        }
      });
      divisions.push(current);
    });
    divisions.sort((a, b) => {
      if (a[state.sort.column] < b[state.sort.column]) {
        return state.sort.direction === 'asc' ? -1 : 1;
      } else if (a[state.sort.column] > b[state.sort.column]) {
        return state.sort.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    this.dataSource.setData(divisions);
    this.dataSource.loading = false;
  }

  getState(): DataTableState {
    return this.stateService.get(this.stateId);
  }

  protected getDisplayedColumns(): Observable<string[]> {
    return this.sectionService.getAllWithoutPageable().pipe(
      tap(sections => {
        this.sections = sections;
      }),
      map(sections => {
        let displayedColumns: string[] = ['description'];
        sections.forEach(section => {
          displayedColumns.push(section.id);
        });
        return displayedColumns;
      })
    );
  }

  setDivisions(assignDivisionTemplate: TemplateRef<AssignDivisionComponent>) {
    this.sidenavService.openSidenav(assignDivisionTemplate, true);
  }

  accept(divisions: Division[]) {
    if (divisions) {
      this.setDivisionsDiff(divisions);
      this.refreshData(this.getState());
    }
    this.assignableDivisionsChange.emit(divisions);
  }

  protected loadDivisions() {
    this.assignableDivisions.forEach(md => {
      this.userDivisions.forEach(ud => {
        if (this.diffDivisions.find(diffDiv => diffDiv.id !== md.id) && ud.id !== md.id) {
          this.diffDivisions.push(md);
        }
      });
    });
  }

  protected setDivisionsDiff(assignNewUserDivision: Division[]) {
    while (this.assignableDivisions.length > 0) {
      this.assignableDivisions.pop();
    }
    assignNewUserDivision.forEach(div => {
      this.assignableDivisions.push(div);
    });

    this.diffDivisions.forEach(div => {
      this.assignableDivisions.push(div);
    });
  }
}
